import { motion } from "framer-motion";
import { useI18n, pick } from "@/lib/i18n";
import { useContent } from "@/lib/content";

const initialsAvatar = (name) =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=020617&color=22D3EE&size=256&bold=true&format=svg`;

export default function Team() {
  const { lang } = useI18n();
  const { content, team } = useContent();
  const sec = content?.team_section;
  if (!sec) return null;
  const header = pick(sec, lang, sec.ru);
  return (
    <section id="team" className="py-16 sm:py-20 lg:py-32 bg-muted/30 border-y border-border/40" data-testid="team-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10 sm:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-semibold mb-4">
            {lang === "ru" ? "Команда" : "Team"}
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-5xl font-semibold tracking-tight">{header.title}</h2>
          <p className="mt-4 text-base text-muted-foreground">{header.subtitle}</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 lg:gap-6">
          {team.map((m, i) => (
            <motion.div
              key={m.id || i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 10) * 0.05 }}
              className="group hover:-translate-y-1.5 transition-transform duration-300 will-change-transform"
              data-testid={`team-member-${i}`}
            >
              <div className="relative aspect-[4/5] rounded-3xl overflow-hidden bg-card border border-border">
                <img
                  src={m.photo || initialsAvatar(m.name)}
                  alt={m.name}
                  onError={(e) => { e.currentTarget.src = initialsAvatar(m.name); }}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-x-0 bottom-0 p-4 pt-10 bg-gradient-to-t from-background via-background/85 to-transparent">
                  <div className="font-heading font-semibold text-base sm:text-lg leading-tight">{m.name}</div>
                  {m.role ? <div className="text-sm text-muted-foreground mt-1">{m.role}</div> : null}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
